import type { Locale } from '@enmon/commons';
import { ConfigProvider } from 'antd';
import type React from 'react';
import { IntlProvider } from 'react-intl';

import { ANTD_LOCALE_MAP } from './locales/antdLocaleMap';

export interface SharedLanguageProviderProps {
  locale: Locale;
  messages: Record<string, string>;
  children: React.ReactNode;
}

export const SharedLanguageProvider: React.FC<SharedLanguageProviderProps> = ({ locale, messages, children }) => {
  return (
    <IntlProvider
      locale={locale}
      messages={messages}
      defaultRichTextElements={{
        strong: str => <strong>{str}</strong>,
      }}
      onError={e => {
        if (import.meta.env.PROD && e.code === 'MISSING_TRANSLATION') return;
        if (!import.meta.env.PROD) console.warn(e);
      }}
    >
      <ConfigProvider locale={ANTD_LOCALE_MAP[locale]}>{children}</ConfigProvider>
    </IntlProvider>
  );
};
